<template>
  <div>
    <b-modal
      id="authorization-modal"
      ref="modal"
      size="sm"
      title="Se requiere confirmar permisos de administrador"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group label="Usuario" label-for="name-input">
          <b-form-input
            id="name-input"
            :state="$v.form.username.$dirty ? !$v.form.username.$error : null"
            v-model="$v.form.username.$model"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Contraseña" label-for="name-input">
          <b-form-input
            type="password"
            id="text-password"
            :state="$v.form.password.$dirty ? !$v.form.password.$error : null"
            v-model="$v.form.password.$model"
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      loading: false,
      form: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    async checkAuthorization() {
      const thisV = this;
      thisV.loading = true;
      const url = "/menu_app/authenticate/";
      const payload = {
        username: thisV.form.username,
        password: thisV.form.password
      };
      try {
        const res = await thisV.$axios.post(url, payload);
        if (res.data.is_staff == true) {
          thisV.$emit("onSuccess");
          this.$bvModal.hide("authorization-modal");
        }
      } catch (e) {
        console.log(e);
        thisV.$emit("onFail");
        thisV.$swal.fire(`Usuario incorrecto o no cuenta con permisos de administrador`, "", "error");
        return;
      }
    },
    resetModal() {
      this.form.username = "";
      this.form.password = "";
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      // Hide the modal manually
      this.$nextTick(() => {
        this.checkAuthorization();
      });
    }
  },
  validations: {
    form: {
      username: { required },
      password: { required }
    }
  }
};
</script>
